import React from 'react';
import { motion } from 'framer-motion';
import { LOGO_URL } from '../constants/site';
const SELECT_SHOT_URL = 'https://cdn.magicpatterns.com/uploads/xtnVxfbfM8JiFY8CBexUir/image.png';
const RESULT_SHOT_URL = 'https://cdn.magicpatterns.com/uploads/iQMLUCthSyCVQfpBnXFz75/Screenshot_2026-06-25_at_10.49.02_PM.png';
const STEPS = [{
  n: '1',
  title: 'Open a post',
  body: 'Head to any post on x.com or twitter.com.'
}, {
  n: '2',
  title: 'Click the icon',
  body: 'Click the X2PIC icon in your Chrome toolbar to start pick mode.',
  showIcon: true
}, {
  n: '3',
  title: 'Select & capture',
  body: 'Click the post and any replies you want, then hit Capture (Esc to cancel).',
  showShot: true
}];
const RESULT_STEP = {
  n: '4',
  title: 'Download or copy',
  body: 'In the result dialog, save the PNG to disk or copy it to your clipboard.'
};
export function HowItWorks() {
  return <section id="how" className="w-full scroll-mt-16 bg-slate-50 py-20 sm:py-24" data-id="element-125">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-126">
        <div className="mx-auto max-w-2xl text-center" data-id="element-127">
          <h2 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl" data-id="element-128">
            Four clicks to a perfect screenshot
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-129">
            No setup, no account — just install and go.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-130">
          {STEPS.map((s, i) => <motion.div key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="relative rounded-2xl border border-slate-200 bg-white p-6" data-id="element-131">
              {s.showIcon && <div className="absolute right-4 top-4" data-id="element-132">
                  <motion.span animate={{
              scale: [1, 0.9, 1]
            }} transition={{
              duration: 1.4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm" data-id="element-133">
                    <img src={LOGO_URL} alt="X2PIC toolbar icon" className="h-7 w-7 object-contain" data-id="element-134" />
                  </motion.span>
                  <motion.span aria-hidden="true" className="pointer-events-none absolute -bottom-2 -right-2" animate={{
              x: [4, -2, 4],
              y: [4, -2, 4]
            }} transition={{
              duration: 1.4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-135">
                    <FingerCursor data-id="element-136" />
                  </motion.span>
                </div>}
              {s.showShot && <div className="absolute right-4 top-4" data-id="element-137">
                  <span className="absolute -left-1.5 -top-1.5 z-10 rounded-full bg-[#1d9bf0] px-1.5 py-0.5 text-[9px] font-bold text-white shadow" data-id="element-138">
                    2 selected
                  </span>
                  <span className="block h-14 w-12 overflow-hidden rounded-lg border-2 border-[#1d9bf0] bg-white shadow-sm ring-2 ring-[#1d9bf0]/20" data-id="element-139">
                    <img src={SELECT_SHOT_URL} alt="X2PIC pick mode with two selected posts highlighted, ready to capture" className="h-full w-full object-cover object-top" data-id="element-140" />
                  </span>
                </div>}
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#1d9bf0] text-base font-bold text-white" data-id="element-141">
                {s.n}
              </span>
              <h3 className="mt-4 text-lg font-semibold text-slate-900" data-id="element-142">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-143">
                {s.body}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4
      }} className="mt-6 grid items-center gap-6 overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 sm:grid-cols-2 sm:p-8" data-id="element-144">
          <div data-id="element-145">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#1d9bf0] text-base font-bold text-white" data-id="element-146">
              {RESULT_STEP.n}
            </span>
            <h3 className="mt-4 text-xl font-semibold text-slate-900" data-id="element-147">
              {RESULT_STEP.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-148">
              {RESULT_STEP.body}
            </p>
          </div>
          <div className="flex justify-center sm:justify-end" data-id="element-149">
            <span className="block w-full max-w-[460px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-md" data-id="element-150">
              <img src={RESULT_SHOT_URL} alt="X2PIC result dialog showing the captured post with style options and Download and Copy buttons" className="h-full w-full object-contain" data-id="element-151" />
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}
function FingerCursor() {
  return <svg width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-152">
      <path d="M9.5 3.2c0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2v8.1l1.1-2.1c.5-1 1.7-1.4 2.7-.9 1 .5 1.4 1.7.9 2.7l-.4.7 1.6-.4c1.1-.3 2.2.4 2.5 1.5l.1.4 1.4-.1c1.1 0 2 .8 2.1 1.9l.4 5.2c.2 3.2-2.2 6-5.4 6.4l-4.6.5c-2.1.2-4.1-.7-5.4-2.4L5 18.6c-.7-1-.5-2.4.5-3.1 1-.7 2.4-.5 3.1.5l.9 1.2V3.2z" fill="#fff" stroke="#0f172a" strokeWidth="1.4" strokeLinejoin="round" data-id="element-153" />
    </svg>;
}